import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ArticleGroupDiscount, defaultArticleGroupDiscount } from "../../models/responses/articleGroupDiscount";

export interface ArticleGroupDiscountState {
    articleGroupDiscountList: ArticleGroupDiscount[];
    articleGroupDiscount: ArticleGroupDiscount;
    isWaitingArticleGroupDiscountPostResponse: boolean;
    isWaitingArticleGroupDiscountPutResponse: boolean;
    totalQueryArticleGroupDiscount: number;
    isWaitingArticleGroupDiscountGetResponse: boolean;
    filteredArticleGroupDiscountList: ArticleGroupDiscount[];
}

const initialState: ArticleGroupDiscountState = {
    articleGroupDiscountList: [],
    articleGroupDiscount: { ...defaultArticleGroupDiscount },
    isWaitingArticleGroupDiscountPostResponse: false,
    isWaitingArticleGroupDiscountPutResponse: false,
    isWaitingArticleGroupDiscountGetResponse: false,
    totalQueryArticleGroupDiscount: 0,
    filteredArticleGroupDiscountList: [],
};

const articleGroupDiscountSlice = createSlice({
    name: 'articleGroupDiscount',
    initialState,
    reducers: {
        setArticleGroupDiscountList: (state, action: PayloadAction<{
            articleGroupDiscounts: ArticleGroupDiscount[];
        }>) => {
            state.articleGroupDiscountList = (action.payload.articleGroupDiscounts || initialState.articleGroupDiscountList);
            return state;
        },
        setArticleGroupDiscount: (state, action: PayloadAction<{
            articleGroupDiscount: ArticleGroupDiscount;
        }>) => {
            state.articleGroupDiscount = action.payload.articleGroupDiscount;
            return state;
        },
        setIsWaitingArticleGroupDiscountPostResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingArticleGroupDiscountPostResponse = action.payload;
        },
        setIsWaitingArticleGroupDiscountPutResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingArticleGroupDiscountPutResponse = action.payload;
        },
        setIsWaitingArticleGroupDiscountGetResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingArticleGroupDiscountGetResponse = action.payload;
        },
        setFilteredArticleGroupDiscountList: (state, action: PayloadAction<{ articleGroupDiscounts: ArticleGroupDiscount[] }>) => {
            state.filteredArticleGroupDiscountList = (action.payload.articleGroupDiscounts || []);
            return state;
        }
    },
});


export const {
    setArticleGroupDiscountList,
    setArticleGroupDiscount,
    setIsWaitingArticleGroupDiscountPostResponse,
    setIsWaitingArticleGroupDiscountPutResponse,
    setIsWaitingArticleGroupDiscountGetResponse,
    setFilteredArticleGroupDiscountList,
} = articleGroupDiscountSlice.actions;

export default articleGroupDiscountSlice.reducer;